// extracted by mini-css-extract-plugin
export default {"type":"t2opuN52SFf0KnF1FTdG","name":"krOlH6n83O8WUs5grcQw","assignedPlanApplied":"uHcLK4AGP5n2F97uDyru","taskHeader":"IKwRGSnsKP9jaluppNiw"};